import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environment/environment';

import { AppConstants } from '../../app.constants';

@Pipe({
  name: 'getImagePath'
})
export class GetImagePathPipe implements PipeTransform {
  public transform(
    value: string,
    height?: number,
    width?: number,
    quality?: number,
    fit?: 'cover' | 'contain' | 'inside' | 'outside'
  ): string {
    const imgFit = fit || 'cover';
    const imgQuality = quality || AppConstants.ASSET_QUALITY;
    let imgUrl = `${environment.directusUrl}/assets/${value}?format=auto&fit=${imgFit}&quality=${imgQuality}`;
    if (width) {
      imgUrl += `&width=${width}`;
    }
    if (height) {
      imgUrl += `&height=${height}`;
    }
    return imgUrl;
  }
}
